import React from 'react'
import { render, screen } from '@testing-library/react'
import BasicCard from '@toasttab/shared/src/components/molecules/CardTypes/BasicCard'
import { BasicCardProps } from '../types.d'

const baseProps: BasicCardProps = {
  cardBorderColor: 'null',
  ctaLabel: 'Link Label',
  ctaLink: '#testLink',
  icon: [
    {
      url: 'https://d2w1ef2ao9g8r9.cloudfront.net/images/icons/display/other/restaurant-exterior.svg'
    }
  ],
  linkIcons: 'link--arrow-right',
  paddingMatrix: [
    {
      paddingTop: '24',
      paddingRight: 'null',
      paddingBottom: 'null',
      paddingLeft: '24',
      mobileTop: '16',
      mobileRight: '24',
      mobileBottom: 'null',
      mobileLeft: '16'
    }
  ],
  sectionHeading: 'Heading',
  subtitle: 'SubHeading',
  sectionDescription: {
    raw: JSON.stringify({
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vitae pulvinar ante. Etiam vel lacus ut mauris sodales pharetra.',
              nodeType: 'text'
            }
          ],
          nodeType: 'paragraph'
        }
      ],
      nodeType: 'document'
    })
  },
  textAlignment: 'center',
  toggleSwitch: false
}

describe('Basic Card Tests', () => {
  it('Should Render BasicCard with Icon, Gray BG, No Border, and Flat Elevation', () => {
    render(<BasicCard {...baseProps} bgColor='bg-gray-0' elevation='flat' />)

    // Get BasicCard container element by class name
    const basiccard = screen.getByTestId('BasicCard-1')
    expect(basiccard).toBeTruthy()
    expect(basiccard).toHaveClass(
      'bg-gray-0',
      'rounded-md',
      'text-center',
      'md:pt-6',
      'md:pb-6',
      'md:pl-6',
      'md:pr-6',
      'pt-4',
      'pb-6',
      'pl-4',
      'pr-6'
    )

    // Get Object element By TestId Icon
    const iconSVG = screen.getByTestId('BasicCard-icon')
    expect(iconSVG).toBeTruthy()

    // Get H3 element
    const heading = screen.getByRole('heading', { level: 4 })
    expect(heading).toBeTruthy()
    expect(heading.classList.contains('text-default')).toBe(true)
    expect(heading.textContent).toBe('Heading')

    // Get Paragraph element By TestId subheading
    const subheading = screen.getByTestId('BasicCard-subheading')
    expect(subheading).toBeTruthy()
    expect(subheading.classList.contains('text-gray-125')).toBe(true)
    expect(subheading.textContent).toBe('SubHeading')

    // Get Paragraph element By TestId description
    const description = screen.getByTestId('BasicCard-description')
    expect(description).toBeTruthy()
    expect(description.classList.contains('text-gray-100')).toBe(true)
    expect(description.textContent).toBe(
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vitae pulvinar ante. Etiam vel lacus ut mauris sodales pharetra.'
    )

    // Get Link element By Role Link
    const cta = screen.getByRole('link')
    expect(cta).toBeTruthy()
    expect(cta).toHaveClass('link--arrow-right')
    expect(cta).toHaveAttribute('href', '#testLink')
    expect(cta.textContent).toBe('Link Label')
  })

  it('Should Render BasicCard with Icon, White BG, No Border, and Raised Elevation', () => {
    render(<BasicCard {...baseProps} bgColor='bg-white' elevation='raised' />)

    // Get BasicCard container element by class name
    const basiccard = screen.getByTestId('BasicCard-1')
    expect(basiccard).toBeTruthy()
    expect(basiccard).toHaveClass(
      'bg-white',
      'rounded-md',
      'shadow-raised',
      'text-center',
      'md:pt-6',
      'md:pb-6',
      'md:pl-6',
      'md:pr-6',
      'pt-4',
      'pb-6',
      'pl-4',
      'pr-6'
    )

    // Get Object element By TestId Icon
    const iconSVG = screen.getByTestId('BasicCard-icon')
    expect(iconSVG).toBeTruthy()

    // Get H3 element
    const heading = screen.getByRole('heading', { level: 4 })
    expect(heading).toBeTruthy()
    expect(heading.classList.contains('text-default')).toBe(true)
    expect(heading.textContent).toBe('Heading')

    // Get Paragraph element By TestId subheading
    const subheading = screen.getByTestId('BasicCard-subheading')
    expect(subheading).toBeTruthy()
    expect(subheading.classList.contains('text-gray-125')).toBe(true)
    expect(subheading.textContent).toBe('SubHeading')

    // Get Paragraph element By TestId description
    const description = screen.getByTestId('BasicCard-description')
    expect(description).toBeTruthy()
    expect(description.classList.contains('text-gray-100')).toBe(true)
    expect(description.textContent).toBe(
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vitae pulvinar ante. Etiam vel lacus ut mauris sodales pharetra.'
    )

    // Get Link element By Role Link
    const cta = screen.getByRole('link')
    expect(cta).toBeTruthy()
    expect(cta).toHaveClass('link--arrow-right')
    expect(cta).toHaveAttribute('href', '#testLink')
    expect(cta.textContent).toBe('Link Label')
  })
})
